import { useContext } from 'react';
import { HouseholdIncomeChartsDataContext } from '../contexts/HouseholdIncomeChartsDataContext';

export const useHouseholdIncomeChartsDataContext = () => {
    return useContext(HouseholdIncomeChartsDataContext);
};
